import { RouterConfig } from '@angular/router';
import { QueryReportComponent } from './query-report.component';
import { QueryReportGraphSelectionsComponent } from './query-reports-graph-selections.component';
import { QueryReportGraphDisplayComponent} from './query-reports-graph-display.component';
import { AuthGuard } from '../authentication/auth-guard.service';

export const QueryReportRoutes: RouterConfig = [
  { path: 'query-reports', component: QueryReportComponent, canActivate: [AuthGuard] },
  { path: 'query-reports-graph-selections', component: QueryReportGraphSelectionsComponent, canActivate: [AuthGuard] },
  { path: 'query-reports-graph-display', component: QueryReportGraphDisplayComponent, canActivate: [AuthGuard]}
];



/** WEBPACK FOOTER **
 ** ./app/query-reports/query-report.routes.ts
 **/